"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Accordion_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Accordion"));
var Content_1 = __importDefault(require("./Content/Content"));
/**
 * The Accordion component can deliver large amounts of information, with individual collapsible sections
 * so that it does not all have to show at once.
 * @child ./Content/Content.tsx
 */
var Accordion = /** @class */ (function (_super) {
    __extends(Accordion, _super);
    function Accordion(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (index) {
            var activeIndex = _this.state.activeIndex;
            var newIndex = activeIndex === index ? -1 : index;
            _this.setState({ activeIndex: newIndex });
        };
        _this.state = { activeIndex: _this.props.defaultActiveIndex };
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    Accordion.prototype.render = function () {
        var _this = this;
        var contents = this.props.children;
        var _a = this.props, defaultActiveIndex = _a.defaultActiveIndex, rest = __rest(_a, ["defaultActiveIndex"]);
        return (React.createElement(Accordion_1.default, __assign({}, rest, { fluid: true }), React.Children.map(contents, function (content, index) {
            if (typeof content === 'object' && content.type === Content_1.default) {
                var _a = content.props, title = _a.title, disabled = _a.disabled, active = _a.active, children = _a.children, onClick_1 = _a.onClick, contentRest = __rest(_a, ["title", "disabled", "active", "children", "onClick"]);
                var handleClick_1 = (disabled ? (function () { return void (0); }) : _this.handleClick);
                var isActive = active !== undefined ? active : _this.state.activeIndex === index;
                return (React.createElement(Content_1.default, __assign({}, contentRest, { title: title, active: isActive, onClick: function () { handleClick_1(index); return onClick_1 && onClick_1(); }, disabled: disabled, key: index }), children));
            }
            else {
                throw new Error('Components inside <Accordion> should be <Accordion.Content />');
            }
        })));
    };
    Accordion.defaultProps = {
        /** Default active index. Set the value to 0 to close all Accordion content */
        defaultActiveIndex: 0,
    };
    Accordion.Content = Content_1.default;
    return Accordion;
}(React.Component));
exports.default = Accordion;
